export const TILESET_LAYER_PREFIX = 'tileset-layer';

// NOTE: this should probably eventually be stored in the tilesets table
export const SUITABILITY_THRESHOLD = 0.58;
export const SUITABILITY_THRESHOLD_FOR_CHESTNUTS = 0.48;

// NOTE: these have to match what's in the database (tilesets table, name column)
export const CHINESE_CHESTNUT_TILESET_NAME = 'chinese-chestnut-v2';
export const BLACK_LOCUST_TILESET_NAME = 'black-locust-v2';
export const HYBRID_POPLAR_TILESET_NAME = 'hybrid-poplar-v2';
export const BLACKCURRANT_TILESET_NAME = 'blackcurrant-v2';
export const AMERICAN_ELDERBERRY_TILESET_NAME = 'american-elderberry-v2';
export const AMERICAN_HAZELNUT_TILESET_NAME = 'american-hazelnut-v2';

export const TILESET_MIN_ZOOM = 8;
export const TILESET_MAX_ZOOM = 16;
